import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import { isAllowedDate, getTodayTime } from '../util/index';

function noop() {}

export function getNowByCurrentStateValue(value) {
  var ret;

  if (value) {
    ret = getTodayTime(value);
  } else {
    ret = moment();
  }

  return ret;
}
export var calendarMixinPropTypes = {
  value: PropTypes.object,
  defaultValue: PropTypes.object,
  onKeyDown: PropTypes.func
};
export var calendarMixinDefaultProps = {
  onKeyDown: noop
};
export var calendarMixinWrapper = function calendarMixinWrapper(ComposeComponent) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_ComposeComponent) {
    _inherits(_class, _ComposeComponent);

    var _super = _createSuper(_class);

    function _class() {
      var _this;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "onSelect", function (value, cause) {
        if (value) {
          _this.setValue(value);
        }

        _this.setSelectedValue(value, cause);
      });

      _defineProperty(_assertThisInitialized(_this), "renderRoot", function (newProps) {
        var _className;

        var props = _this.props;
        var prefixCls = props.prefixCls;
        var className = (_className = {}, _defineProperty(_className, prefixCls, 1), _defineProperty(_className, "".concat(prefixCls, "-hidden"), !props.visible), _defineProperty(_className, props.className, !!props.className), _defineProperty(_className, newProps.className, !!newProps.className), _className);
        return /*#__PURE__*/React.createElement("div", {
          ref: _this.saveRoot,
          className: "".concat(classnames(className)),
          style: _this.props.style,
          tabIndex: "0",
          onKeyDown: _this.onKeyDown
        }, newProps.children);
      });

      _defineProperty(_assertThisInitialized(_this), "setSelectedValue", function (selectedValue, cause) {
        // if (this.isAllowedDate(selectedValue)) {
        if (!('selectedValue' in _this.props)) {
          _this.setState({
            selectedValue: selectedValue
          });
        }

        if (_this.props.onSelect) {
          _this.props.onSelect(selectedValue, cause);
        } // }

      });

      _defineProperty(_assertThisInitialized(_this), "setValue", function (value) {
        var originalValue = _this.state.value;

        if (!('value' in _this.props)) {
          _this.setState({
            value: value,
            panelValue: ''
          });
        }

        if (originalValue && value && !originalValue.isSame(value) || !originalValue && value || originalValue && !value) {
          _this.props.onChange(value);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "isAllowedDate", function (value) {
        var disabledDate = _this.props.disabledDate;
        var disabledTime = _this.props.disabledTime;
        return isAllowedDate(value, disabledDate, disabledTime);
      });

      return _this;
    }

    _createClass(_class, null, [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(nextProps, prevState) {
        // Use origin function if provided
        if (ComposeComponent.getDerivedStateFromProps) {
          return ComposeComponent.getDerivedStateFromProps(nextProps, prevState);
        }

        var value = nextProps.value,
            selectedValue = nextProps.selectedValue;
        var newState = {};

        if ('value' in nextProps) {
          newState.value = value || nextProps.defaultValue || getNowByCurrentStateValue(prevState.value);
        }

        if ('selectedValue' in nextProps) {
          newState.selectedValue = selectedValue;
        }

        return newState;
      }
    }]);

    return _class;
  }(ComposeComponent), _defineProperty(_class, "displayName", 'CalendarMixinWrapper'), _defineProperty(_class, "defaultProps", ComposeComponent.defaultProps), _temp;
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/mixin/CalendarMixin.js